import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Eye, EyeOff, ArrowRight, CheckCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import '../admin/Auth.css';

export default function SupplierResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '', confirmPassword: '' });
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (form.password !== form.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (form.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post(`/auth/supplier/reset-password/${token}`, {
        password: form.password
      });
      toast.success(res.data.message);
      setSuccess(true);
      setTimeout(() => navigate('/supplier/login'), 2000);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-layout">
        <div className="auth-promo auth-promo--supplier">
          <div className="auth-promo__overlay" />
          <div className="auth-promo__content">
            <div className="auth-promo__logo">
              <img src="/1879-22.png" alt="1879 Tech Hub" className="auth-logo-img" />
            </div>
            <div className="auth-promo__text">
              <span className="auth-promo__tag">Vendor Portal</span>
              <h1 className="auth-promo__headline">
                Artwork<br /><em>Delivery</em>
              </h1>
            </div>
          </div>
        </div>

        <div className="auth-form-panel">
          <div className="auth-form-wrap">
            <div style={{ textAlign: 'center', paddingTop: 40 }}>
              <CheckCircle size={48} color="#28a745" style={{ marginBottom: 16 }} />
              <h2 className="auth-form-title">Password Reset Successfully</h2>
              <p className="auth-form-sub">Your password has been reset. Redirecting to login...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-layout">
      <div className="auth-promo auth-promo--supplier">
        <div className="auth-promo__overlay" />
        <div className="auth-promo__content">
          <div className="auth-promo__logo">
            <img src="/1879-22.png" alt="1879 Tech Hub" className="auth-logo-img" />
          </div>
          <div className="auth-promo__text">
            <span className="auth-promo__tag">Vendor Portal</span>
            <h1 className="auth-promo__headline">
              Artwork<br /><em>Delivery</em><br />Made Simple
            </h1>
            <p className="auth-promo__sub">
              Upload position proofs and colour proof scans, track approvals in real time, and stay in sync with the CHI packaging team.
            </p>
          </div>
        </div>
      </div>

      <div className="auth-form-panel">
        <div className="auth-form-wrap">
          <div className="auth-form-logo-sm">
            <img src="/1879-22.png" alt="1879 Tech Hub" className="auth-logo-img" />
          </div>
          <div className="auth-form-header">
            <h2 className="auth-form-title">Create New Password</h2>
            <p className="auth-form-sub">Enter a new password to regain access to your account</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label className="form-label">New Password</label>
              <div className="input-password-wrap">
                <input
                  className="form-input"
                  type={showPass ? 'text' : 'password'}
                  placeholder="Enter new password"
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  required
                />
                <button type="button" className="input-eye-btn" onClick={() => setShowPass(!showPass)}>
                  {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Confirm Password</label>
              <div className="input-password-wrap">
                <input
                  className="form-input"
                  type={showConfirm ? 'text' : 'password'}
                  placeholder="Confirm your password"
                  value={form.confirmPassword}
                  onChange={e => setForm({ ...form, confirmPassword: e.target.value })}
                  required
                />
                <button type="button" className="input-eye-btn" onClick={() => setShowConfirm(!showConfirm)}>
                  {showConfirm ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-lg w-full auth-submit-btn" disabled={loading}>
              {loading ? <span className="spinner" /> : <>Reset Password <ArrowRight size={16} /></>}
            </button>
          </form>

          <div className="auth-form-footer">
            <p>Back to login? <Link to="/supplier/login" className="auth-link">Sign in</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
}
